<div class="w-100">
    <button (click)="startAddinAdress()" class="btn btn-primary btn-sm" *ngIf="!newAddress">Tilføj adresse</button>
    <form (submit)="addAddress()" *ngIf="newAddress" class="form-inline">

        <div class="mb-2">

            <label class="form-label">Adresse type</label>
            <select [(ngModel)]="newAddress.address_type" name="address_type" class="form-control form-select">
                <option i18n [ngValue]="null">Vælg adresse type</option>
                <option *ngFor="let adrresType of missingAdressTypes"

                        [ngValue]="adrresType.address_type">{{ adrresType.name }}
                </option>

            </select>
        </div>
        <button type="submit" class="btn btn-primary btn-sm">Tilføj adresse</button>
    </form>
    <hr>
</div>

    <div class="row" *ngIf="!newAddress">
        <ng-template ngFor let-shipment_address [ngForOf]="_shipment.shipment_addresses">
            <div
                    [ngClass]="{'col-4': !simple, 'col-12': simple }"
                    *ngIf="shipment_address.address_type === 'receiver' || shipment_address.address_type === 'sender' || shipment_address.address_type === 'pickup' || (shipment_address.address_type === 'droppoint' && _shipment.isDroppoint())">

                <ng-container *ngIf="shipment_address.address_type === 'droppoint' && _shipment.isDroppoint()">
                <p class="h4">{{ shipment_address.address_type === 'droppoint' ? 'Droppoint' :''}}</p>
                    <button (click)="lookupDroppoint()" type="button" class="btn  btn-info  mb-3">Search</button>
                    <ol class="list-group list-group-numbered">
                        <li *ngFor="let droppoint of droppointResults; let i = index" class="list-group-item d-flex justify-content-between align-items-start">
                            <div class="ms-2 me-auto">
                                <div class="fw-bold">{{droppoint.name}}</div>

                                {{droppoint.address}}<br>
                                {{droppoint.address2}}<br>
                                {{droppoint.zipcode}} -                                    {{droppoint.city}}
                                {{droppoint.country}}<br>

                                Afstand: {{droppoint.distance ? (droppoint.distance / 1000) + ' km' : '-'}}<br>


                                <button (click)="pickDroppoint(droppoint)" type="button" class="btn  btn-info  mb-3">Vælg</button>
                            </div>
                            <span class="badge text-bg-primary rounded-pill">{{ droppoint.id }}</span>
                        </li>
                    </ol>

                    <div class="mb-2">
                        <label for="email_receiver" class="form-label">Droppoint ID</label>
                        
                            <input type="text" class="form-control" id="email_receiver" name="email_receiver"
                                   [(ngModel)]="shipment_address.droppoint_reference">
                    </div>
                </ng-container>

                <ng-container *ngIf="shipment_address.address_type === 'receiver' || shipment_address.address_type === 'sender' || shipment_address.address_type === 'pickup'">

                    <ng-container [ngSwitch]="shipment_address.address_type">
                        <p class="h4" *ngSwitchCase="'receiver'">Modtager</p>
                        <p class="h4" *ngSwitchCase="'sender'">Afsender</p>
                        <p class="h4" *ngSwitchCase="'pickup'">Afhenter</p>
                        <p class="h4" *ngSwitchDefault>Ukendt adressetype</p>
                    </ng-container>

                    <div class="mb-2 d-flex justify-content-between gap-2">
                        <button (click)="pickAdress(shipment_address)" class="btn btn-secondary btn-sm">Søg Adressebog</button>
                        <button (click)="saveInAdressbook(shipment_address)" class="btn btn-secondary btn-sm">Gem i adressebog</button>
                    </div>

                    <div class="mb-2">
                        <label for="email_receiver" class="form-label">Email</label>
                            <input type="text" class="form-control" id="email_receiver" name="email_receiver"
                                   [(ngModel)]="shipment_address.email_receiver">
                    </div>
                </ng-container>

                <div class="mb-2">
                    <label for="shipment-name-1-receiver" class="form-label">Navn 1
                       </label>

                        <input type="text" class="form-control" id="shipment-name-1-receiver"
                               name="name_1_receiver"
                               [(ngModel)]="shipment_address.name_1_receiver">
                </div>

                <div class="mb-2">
                    <label for="shipment-name-2-receiver" class="form-label">Navn 2
                       </label>

                        <input type="text" class="form-control" id="shipment-name-2-receiver"
                               name="name_2_receiver"
                               [(ngModel)]="shipment_address.name_2_receiver">

                </div>
                <div class="mb-2">
                    <label for="shipment-name-1-receiver" class="form-label"><strong>Adresse 1
                       </strong></label>
                        <input type="text" class="form-control" id="shipment-address-1-receiver"
                               name="address_1_receiver"
                               [(ngModel)]="shipment_address.adress_1_receiver">
                </div>

                <div class="mb-2">
                    <label for="shipment-address-2-receiver" class="form-label">Adresse 2
                       </label>
                        <input type="text" class="form-control" id="shipment-address-2-receiver"
                               name="address_2_receiver"
                               [(ngModel)]="shipment_address.adress_2_receiver">
                </div>

                <div class="mb-2">
                    <label for="shipment-postal-code-receiver" class="form-label"><strong>Postnummer
                       </strong></label>
                        <input type="text" class="form-control" id="shipment-postal-code-receiver"
                               name="postal_code_receiver" [(ngModel)]="shipment_address.postal_code_receiver">
                </div>

                <div class="mb-2">
                    <label for="shipment-city-receiver" class="form-label">By</label>
                        <input type="text" class="form-control" id="shipment-city-receiver" name="city_receiver"
                               [(ngModel)]="shipment_address.city_receiver">
                </div>

                <div class="mb-2">
                    <label for="shipment-country-code-receiver" class="form-label">Landekode
                    </label>
                    <select
                            name="country_code_receiver"
                            class="form-select"
                            [(ngModel)]="shipment_address.country_code_receiver">
                        <option *ngFor="let country of shipmentsService.countries"
                                [value]="country.code">{{ country.name }}
                        </option>
                    </select>
                </div>

                <div class="mb-2">
                    <label for="shipment-phone-receiver" class="form-label">Mobil</label>
                        <input type="text" class="form-control" id="shipment-phone-receiver"
                               name="phone_receiver"
                               [(ngModel)]="shipment_address.phone_receiver">
                </div>

                <ng-container *ngIf="shipment_address.address_type === 'receiver' && !simple">
                    <hr>

                    <button (click)="checkAddress()" type="button" class="btn  btn-info  mb-3"
                            [disabled]="checking">{{ checking ? 'Checking...' : 'Recheck address for coordinates' }}
                    </button>

                    <div *ngIf="!checking">
                        <p *ngIf="addressesFound === 1" class="text-success">
                            Found a single match!
                        </p>

                        <div *ngIf="addressesFound <= 25">
                            <ul class="p-0" style="list-style: none;">
                                <ng-template ngFor let-address [ngForOf]="addresses">
                                    <li class="mb-2">{{ address.betegnelse }}

                                        <button class="btn  btn-sm  btn-default" (click)="showOnMap(address)"
                                                [disabled]="saving">Vis på kort
                                        </button>

                                        <button class="btn  btn-sm  btn-info" (click)="pickAddress(address)"
                                                [disabled]="saving">Vælg og gem
                                        </button>

                                    </li>
                                </ng-template>
                            </ul>
                        </div>

                        <p *ngIf="addressesFound > 25 || addressesFound === 0" class="text-danger">
                            {{ addressesFound > 0 ? 'Found ' + addressesFound + ' addresses, please adjust address and postal code' : 'Found no adresses' }}
                        </p>
                    </div>

                    <ng-container *ngIf="!simple">
                        <ngb-alert [dismissible]="false" *ngIf="moved" [type]="'info'">
                            Du har ændret position manuelt - tryk 'Gem' for at gemme denne position, eller vælg en af
                            resultaterne
                        </ngb-alert>
                        <div style="height: 300px; width: 100%;position:relative;">
                            <app-map [createDragable]="true" [intialLocation]="mapCenter"
                                     (markerMoved)="onDragEnd($event)"></app-map>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </ng-template>
    </div>
